import {Component} from '@angular/core';
import {CommonService} from '../../../../shared/services/common.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ResourcesHubService} from '../../core/resources-hub.service';
import {SharedService} from "../../../../shared/core/shared.service";
import {Subject, switchMap, takeUntil} from "rxjs";

@Component({
  selector: 'app-add-image',
  templateUrl: './add-image.component.html',
  styleUrls: ['./add-image.component.css']
})
export class AddImageComponent {

  imageForm: FormGroup = new FormGroup<any>({
    imageUrl: new FormControl('', [Validators.required])
  });
  data: any;
  allowExtension = [
    'jpeg', 'jpg', 'image/jpg', 'image/png', 'image/jpeg', 'png', 'image/webp',
    'webp'
  ]

  errorMessages: any = {};

  errorMessageMap = {
    imageUrl: {
      required: 'This field is required',
    },
  }
  loading: boolean = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private commonService: CommonService, private resourceHubService: ResourcesHubService, private sharedService: SharedService) {
  }

  ngOnInit(): void {
    if (this.data?.layoutData?.imageUrl) {
      this.imageForm.patchValue({
        imageUrl: this.data?.layoutData?.imageUrl
      })
    } else {
      this.imageForm.patchValue({
        imageUrl: ''
      })
    }
  }

  onImageSelection(event): void {
    this.loading = true
    const selectedFile = event[0];
    if (selectedFile) {
      const fileExtension = selectedFile.type;
      const fileName = selectedFile.name
      const fileSize = selectedFile.size / 1024 / 1024;

      if (!this.allowExtension.includes(fileExtension)) {
        this.checkForErrors();
        this.commonService.notification('Supported formats are png, jpg, jpeg, webp', 'warning')
        return
      }
      if (fileSize > 5) {
        this.checkForErrors();
        this.commonService.notification('Image size should be less than 5MB', 'warning');
        return
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const result = e.target.result;
        const blob = new Blob([result], {type: selectedFile.type});
        this.uploadImage(selectedFile, blob)
      }
      reader.readAsArrayBuffer(selectedFile);
    } else {
      //   error block
      this.commonService.notification('File is not selected , please try again', 'warning');
    }
  }

  uploadImage(selectedFile, blob) {
    const fileName = selectedFile.name;
    const contentType = selectedFile.type;
    let imagePath = ''
    this.sharedService.getSignedUrlForImageUpload({fileName, contentType})
      .pipe(takeUntil(this.onDestroy), switchMap((signedUrl) => {
        const formData: FormData = new FormData();
        formData.append('file', blob);
        imagePath = signedUrl?.data?.path
        return this.sharedService.uploadImageToCdn(signedUrl?.data?.uploadUrl, blob, contentType)
      })).subscribe(signedUrl => {
      const updatedData = JSON.parse(JSON.stringify(this.data))
      updatedData.layoutData.imageUrl = imagePath
      this.resourceHubService.sendDataToParent(updatedData)
      this.resourceHubService.lastUpdatedId.next(updatedData.layoutData.uuid)
      this.loading = false
    }, err => {
      this.loading = false
    })
  }

  deleteSelectedImage() {
    this.loading = true;
    this.sharedService.deleteUploadedImage({
      path: this.imageForm.value.imageUrl
    }).pipe(takeUntil(this.onDestroy)).subscribe(response => {
      this.loading = false;
      const updatedData = JSON.parse(JSON.stringify(this.data));
      updatedData.layoutData.imageUrl = '';
      this.resourceHubService.sendDataToParent(updatedData);
    }, err => {
      const updatedData = JSON.parse(JSON.stringify(this.data));
      updatedData.layoutData.imageUrl = '';
      this.resourceHubService.sendDataToParent(updatedData);
      this.loading = false;
    })
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.imageForm, this.errorMessageMap, currentField))
    };
  }


  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
